import { createSelector } from "reselect"
import { get, chain, find, map } from "lodash"
import { getCurrent } from "./forecast"
import { COLORS } from "helpers/analyzeConstants"

export const CATEGORIES = [{ id: "dailyForecast", label: "Daily Forecast", color: COLORS[0] }]
export const FACTORS = {
  expectedReturn: {
    category: "dailyForecast",
    label: "Forecast Return",
  },
}

const getRawDisplayType = state => get(state, "modules.analyzeForecast.displayType")
export const getForecastId = (_, props) => get(props, "params.forecastId", get(props, "forecastId"))

function getFactorLabel(factors, id) {
  const factor = get(factors, id, { label: id })
  return factor.overviewLabel || factor.label
}

function getFactorCategory(factors, id) {
  return get(factors, [id, "category"])
}

export const getDisplayType = createSelector(
  [getRawDisplayType],
  (displayType) => {
    if (find(CATEGORIES, cat => cat.id === displayType)) {
      return displayType
    }

    return CATEGORIES[0].id
  },
)

export const getDisplayTypeName = createSelector(
  [getRawDisplayType],
  (displayType) => {
    const category = find(CATEGORIES, cat => cat.id === displayType)
    if (category) {
      return category.label
    }

    return CATEGORIES[0].label
  },
)

export const getAllItems = createSelector(
  [getCurrent],
  (lastDatum) => {
    return map(FACTORS, (_, id) => ({
      id,
      label: getFactorLabel(FACTORS, id),
      category: getFactorCategory(FACTORS, id),
      lastValue: get(lastDatum, ["factors", id], 0),
      field: `factors.${id}`,
      disabled: false,
    }))
  },
)

export const getAllCategoryItems = createSelector(
  [getAllItems, getDisplayType],
  (items, displayType) => chain(items)
    .filter(item => item.category === displayType)
    .orderBy(item => Math.abs(item.lastValue), ["desc"])
    .value(),

)

export const getOrderedCategoryItems = createSelector(
  [getAllItems, getDisplayType],
  (items, displayType) => chain(items)
    .filter(item => item.category === displayType)
    .orderBy(item => Math.abs(item.lastValue), ["asc", "desc"])
    .value(),
)
